module.exports = __webpack_public_path__ + "img/logo.894572d9.png";